import { BllSubeler } from './../providers/bll/bll-subeler';
import { NL_Subeler } from './../models/NL_Subeler';
import { BllProgramAyarlari } from './../providers/bll/bll-programayarlari';
import { PagesProvider } from './../providers/pages-provider';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';
import { StatusBar } from '@ionic-native/status-bar';
import { HomePage } from './../pages/home/home';
import { SplashScreen } from '@ionic-native/splash-screen';
import { DalProvider } from './../providers/dal/dal';

import { BllServisBilgisi } from './../providers/bll-servis-bilgisi';
import { GirisPage } from './../pages/giris/giris';
import { Ortak } from './../providers/ortak';
import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, Events, MenuController } from 'ionic-angular';
import { AndroidFullScreen } from '@ionic-native/android-full-screen';
import { NL_ProgramAyarlari } from '../models/NL_ProgramAyarlari';
import { NL_Servis } from '../models/NL_Servis';


@Component({
  templateUrl: 'app.html'

})

export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any = GirisPage;
  suankitarih;
  aktifKullanici = "";
  kullaniciyetkiseviyesi: any;
  cihazid: number = 0;
  cihazbilgisi: any = { ID: "", CihazTipi: "" };

  constructor(public platform: Platform,
    public pagesProvider: PagesProvider,
    public androidFullScrenn: AndroidFullScreen,
    public ortak: Ortak,
    public dalProvider: DalProvider,
    public splashScreen: SplashScreen,
    public statusBar: StatusBar,
    public toastcontroler: ToastController,
    public events: Events,
    public menu: MenuController,
    public splashscreen: SplashScreen, ) {
    // this.ortak.storeagePersonelCikar();
    this.initializeApp();

  }


  initializeApp() {
    this.platform.ready().then(() => {
      Ortak.sqlType = "web";
      var sqlDriver;
      if (Ortak.sqlType == "web") {
        sqlDriver = {
          database: "VT.db",
          type: "websql",
          storage: "web",
        };
      }
      else {
        sqlDriver = {
          database: "MRC_5.db",
          type: "websql",
          storage: "sqlite",
        };
      }
      this.dalProvider.createAndGetConnection(sqlDriver).then(b => {
        var bllprogramayari = new BllProgramAyarlari();
        bllprogramayari.getAll().then(a => {
          var sonuc = <any>a;
          if (sonuc.length <= 0) {
            var ayar = new NL_ProgramAyarlari();
            ayar.CariListeSayisi = 50;
            ayar.MalzemeListeSayisi = 50;
            ayar.SatisFaturasiStoktanDusecekMi = 1;
            ayar.fisyazicioto = 0;
            ayar.FisYaziciAdi = "";
            ayar.BarkodYaziciAdi = "";
            bllprogramayari.add(ayar).then(b => {
              this.ortak.storageProgramAyarEkle(ayar);
            })
          }
          else {
            this.ortak.storageProgramAyarEkle(a[0]);
          }
        })
      })
      this.dalProvider.createAndGetConnection(sqlDriver).then(a => {
        var bllServisBilgisi = new BllServisBilgisi();
        var bblsubeler=new BllSubeler();
        bllServisBilgisi.getAll().then(a => {
          var sonuc = <any>a;
          if (sonuc.length <= 0) {
            var servis = new NL_Servis();
 
          servis.ADRES = "http://localhost:1010";
         // servis.ADRES = "http://acarservis.netlifeyazilim.com";
            servis.Tanim = "Şube";
            var sube = new NL_Subeler();
            sube.SubeAdi = servis.Tanim;
            sube.SubeAdres = servis.ADRES;
            bblsubeler.add(sube).then(a=>{

            });
            bllServisBilgisi.add(servis).then(b => {
              this.ortak.storageServisBilgisiEkle(servis);
              this.nav.setRoot(GirisPage);
            })
          }
          else {
            this.ortak.storageServisBilgisiEkle(a[0]);
            this.nav.setRoot(GirisPage);
          }
        })
      })
      this.ortak.storagecihazrefresh();
      this.androidFullScrenn.isImmersiveModeSupported()
        .then(() => this.cihaztelefon())
        .catch((error: any) => this.cihazbrowser());
      this.splashScreen.hide();
    });
    this.menuleriOlustur();
  }

  menuler = [];
  menuleriOlustur() {

    this.pagesProvider.menuler().then(a => {
      var sonuc = <any>a;
      this.menuler = sonuc.YONETICI_LEFT_MENU;
    })




  }
  menuOpened(refresher) {

  }
  subedegistir() {
    this.nav.setRoot(GirisPage);
  }
  cihaztelefon() {
    this.cihazbilgisi.ID = 1;
    this.cihazbilgisi.CihazTipi = "Telefon";
    this.ortak.storagecihazkontrol(this.cihazbilgisi);

  }
  cihazbrowser() {
    this.cihazbilgisi.ID = 2;
    this.cihazbilgisi.CihazTipi = "Browser";
    this.ortak.storagecihazkontrol(this.cihazbilgisi);

  }
  segmentChanged() {
    //yenileme işlemleri
  }

  openPage(menu) {
    var componentType = typeof menu.PAGE_COMPONENT;
    var component;
    if (componentType === "string")
      component = this.pagesProvider.components[menu.PAGE_COMPONENT];
    else
      component = menu.PAGE_COMPONENT;
    if (component == HomePage) {
      this.nav.setRoot(HomePage);
    }
    else {
      if (component == GirisPage) {
      }
      this.nav.push(component);
      this.menu.close();
    }
  }

  menuItemClick(item) {
    var pagesProvider = new PagesProvider();
    var componentType = typeof item.TS_KOMPONENT;
    var component;
    if (componentType === "string")
      component = pagesProvider.components[item.TS_KOMPONENT];
    else
      component = item.TS_KOMPONENT;
    if (component == GirisPage) {
    }
    this.nav.push(component);
  }

  menuClosed() {

  }
  kapat() {
    this.ortak.showConfirmAlert("Uyarı", "Uygulama Kapanacak. Devam etmek istiyor musunuz?").then(k => {
      this.platform.exitApp();
    })
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts